import Cookies from 'universal-cookie'
import querystring from 'query-string'
import * as types from './constants'
import { API_HOSTNAME } from '../../GlobalConfig'

const cookie = new Cookies()
const getOpts = (method, data) => {
  const token = cookie.get('TKN_MINAPOLI')

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: data && JSON.stringify(data),
  }
}

export const getUserCreatedEvents = (params) => {
  const qs = querystring.stringify(params)
  const authOpts = getOpts()

  return {
    types: types.GET_USER_CREATED_EVENTS,
    promise: fetch(`${API_HOSTNAME}/v1/user/events?${qs}`, authOpts),
    // promise: fetch(`${API_HOSTNAME}/v1/user/slug-3/events?${qs}`, options),
  }
}

export const getUserCreatedInfos = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_USER_CREATED_INFOS,
    promise: fetch(`${API_HOSTNAME}/v1/user/info`, authOpts),
  }
}

export const getUserCreatedProducts = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_USER_CREATED_PRODUCTS,
    promise: fetch(`${API_HOSTNAME}/v1/user/pasar`, authOpts),
  }
}

export const getFavoriteProducts = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_FAVORITE_PRODUCTS,
    promise: fetch(`${API_HOSTNAME}/v1/user/favorite/product`, authOpts),
  }
}

export const getFavoriteEvents = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_FAVORITE_EVENTS,
    // promise: fetch('http://minapoli-mock.surge.sh/api/profile/pasar_list_category'),
    promise: fetch(`${API_HOSTNAME}/v1/user/favorite/event`, authOpts),
  }
}

export const getFavoriteInfos = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_FAVORITE_INFOS,
    // promise: fetch('http://minapoli-mock.surge.sh/api/profile/pasar_list_category'),
    promise: fetch(`${API_HOSTNAME}/v1/user/favorite/info`, authOpts),
  }
}

export const createPasarMina = (data) => {
  const authOpts = getOpts('POST', data)

  return {
    types: types.CREATE_PRODUCT,
    promise: fetch(`${API_HOSTNAME}/v1/product`, authOpts),
  }
}

export const createEventMina = (data) => {
  const authOpts = getOpts('POST', data)

  return {
    types: types.CREATE_EVENT,
    promise: fetch(`${API_HOSTNAME}/v1/eventmina`, authOpts),
  }
}

export const createInfoMina = (data) => {
  const authOpts = getOpts('POST', {
    ...data,
    tags: ['hehe'],
  })

  return {
    types: types.CREATE_INFO,
    promise: fetch(`${API_HOSTNAME}/v1/infomina`, authOpts),
  }
}

export const getNotification = () => {
  const authOpts = getOpts()

  return {
    types: types.GET_NOTIFICATION,
    promise: fetch(`${API_HOSTNAME}/v1/user/notification`, authOpts),
  }
}



// WEBPACK FOOTER //
// ./src/modules/Profile/actions.js